import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Cube
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug
        
        this.setModel()

        console.log('Cube initialized')
    }

    setModel()
    {
        let centerCubeMaterial;

        if(this.experience.isMobile)
        {
            centerCubeMaterial = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                wireframe: true
            });
        }
        else
        {
            centerCubeMaterial = new THREE.MeshPhysicalMaterial({
                color: 0xffffff,
                metalness: 0.1,
                roughness: 0.1,          // Low roughness for clarity
                transmission: 0.98,       // Very high transmission to see through
                transparent: true,
                opacity: 0.3,            // More transparent
                //side: THREE.DoubleSide,  
                side: THREE.BackSide,
                thickness: 0.5,          // Add thickness for refraction
                ior: 1.5,               // Index of refraction like glass
                reflectivity: 0.2,      // Subtle reflections
                clearcoat: 0.3,
                clearcoatRoughness: 0.1,
                depthWrite: false,       // Needed for proper transparency
                depthTest: true
            });

        }
        
        
        this.model = new THREE.Mesh(
            new THREE.BoxGeometry(7, 7, 7),
            centerCubeMaterial
        );

        this.model2 = new THREE.Mesh(   
            new THREE.BoxGeometry(7.3, 7.3, 7.3),
            centerCubeMaterial
        );
        
        this.scene.add(this.model);
        this.scene.add(this.model2);

        // Debug
        if(this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('HCcube')
            
            // Add uniform scale control
            const updateScale = (value) => {
                this.model.scale.set(value, value, value)
            }

            const updateRoughness = (value) => {
                this.model.material.roughness = value
                this.model2.material.roughness = value
                this.model.material.needsUpdate = true
            }

            this.debugFolder.add({ scale: 1 }, 'scale')
                .name('scale')
                .min(0.001)
                .max(10)
                .step(0.001)
                .onChange(updateScale)
            
                

            this.debugFolder.add({ roughness: 0.5 }, 'roughness')
                .name('roughness')
                .min(0)
                .max(1)
                .step(0.01)
                .onChange(updateRoughness)
        }
    }

    update()
    {
        this.model.rotation.y -= 0.01
        this.model2.rotation.y -= 0.01
    }
}